import React, { memo } from "react";
import { useI18n } from "./integrations/formatjs/I18nContext";
import { shallowEqual } from "./utils/shallowEqual";
const I18nTime = ({ domain, value, hour, minute, timeZone, }) => {
    const intl = useI18n({ domain });
    return React.createElement(React.Fragment, null, intl.formatTime(value, { hour, minute, timeZone }));
};
const MemoizedI18nTime = memo(I18nTime, shallowEqual);
export { MemoizedI18nTime as I18nTime };
